import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './dayjsTimeExtends';
import 'react-perfect-scrollbar/dist/css/styles.css';
import {
  Route,
  unstable_HistoryRouter as Router,
  Routes,
} from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { Routes as AppRoutes } from './routes';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { history, store } from './store';
import Root from './routes/Root';
import Login from './routes/Login';
import Receipts from './routes/Receipts';
import Inbox from './routes/Inbox';
import Reports from './routes/Reports/view';
import Settings from './routes/Settings/view';
import ProtectedRoute from './routes/protectedRoute';
import Dashboard from './routes/Dashboard';
import LoadingScreen from './components/LoadingScreen';
import DetailsDrawer from './DetailsDrawer/view';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AuthCallback from './routes/AuthCallback';

const container = document.getElementById('root')!;
const root = createRoot(container);

const clientId = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID ?? '';
root.render(
  <GoogleOAuthProvider clientId={clientId}>
    <React.StrictMode>
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ThemeProvider theme={theme}>
            <Router history={history as any}>
              <Suspense fallback={<LoadingScreen />}>
                <Routes>
                  <Route
                    path={AppRoutes.Root}
                    element={
                      <ProtectedRoute>
                        <Root />
                      </ProtectedRoute>
                    }
                  >
                    <Route path={AppRoutes.Root} element={<Dashboard />} />
                    <Route path={AppRoutes.Receipts} element={<Receipts />} />
                    <Route path={AppRoutes.Inbox} element={<Inbox />} />
                    <Route path={AppRoutes.Reports} element={<Reports />} />
                    <Route path={AppRoutes.Settings} element={<Settings />} />
                    <Route
                      path={AppRoutes.SettingsProfile}
                      element={<Settings />}
                    />
                    <Route
                      path={AppRoutes.SettingsSubscriptions}
                      element={<Settings />}
                    />
                  </Route>
                  <Route
                    path={AppRoutes.Login}
                    element={
                      <LoadingScreen>
                        <Login />
                      </LoadingScreen>
                    }
                  />
                  <Route
                    path={AppRoutes.AuthCallback}
                    element={<AuthCallback />}
                  />
                </Routes>
                <DetailsDrawer />
              </Suspense>
            </Router>
          </ThemeProvider>
        </LocalizationProvider>
      </Provider>
    </React.StrictMode>
  </GoogleOAuthProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
